export class MultipartFile {
  file: File;
  fileNameWithPath: string;

  constructor(file: File, fieldName: string, subformName: string = null, subformIndex: number = 0) {
    this.file = file;
    this.setFileName(fieldName, subformName, subformIndex);
  }

  private setFileName(fieldName: string, subformName: string, subformIndex: number): void {
    if (subformName) {
      this.fileNameWithPath = `${subformName}[${subformIndex}]/${fieldName}/${this.file.name}`;
    } else {
      this.fileNameWithPath = `${fieldName}/${this.file.name}`;
    }
  }

  public static getFileNameWithoutPath(multipartFile: MultipartFile): string {
    if (multipartFile.file) {
      return multipartFile.file.name;
    }
    const fileNameParts = multipartFile.fileNameWithPath.split('/');
    return fileNameParts[fileNameParts.length - 1];
  }

  public static isMultipartFile(value: any): boolean {
    return (
      value instanceof MultipartFile ||
      ('file' in value && value.file instanceof File && 'fileNameWithPath' in value && typeof value.fileNameWithPath === 'string')
    );
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/components/controls/multipart-files/multipart-file.ts